export enum SourceType {
  Column = "Column",
  Dataset = "Dataset",
  InputVariable = "Input Variable",
  Dependency = "Dependency",
}

/**
 * Items in a `SourcesV2` group. `value` is what gets persisted to the block
 * config (either a sibling column title for same-sheet, or a canonical
 * source-resolver string `tid.sid.cid` for cross-sheet / cross-table). The
 * `label` is purely display, and `sheetLabel` / `tableLabel` hang off the
 * item so the search layer can show the parent sheet inline without a
 * second lookup.
 */
export interface SourceItem {
  id: string;
  label: string;
  value: string;
  sheetLabel?: string;
  tableLabel?: string;
  parentLabel?: string;
}

/**
 * Two-layer source group: one entry per (smart_table, sheet) pair. Columns
 * in `items` are persisted as canonical resolver strings so they survive
 * rename/move of the upstream column.
 */
export interface SourceSheetGroup {
  label: string;
  items: SourceItem[];
  isSameTable?: boolean;
}

export interface SourceColumnGroup {
  id?: string;
  label: string;
  items: SourceItem[];
}

/**
 * Richer sources shape used by Smart-Table blocks that need to navigate
 * cross-sheet / cross-table. Non-Smart-Table call sites keep passing the
 * legacy `Record<SourceType, string[]>` shape and get exactly the same
 * rendering as before.
 */
export interface SourcesV2 {
  [SourceType.Column]?: SourceItem[];
  [SourceType.InputVariable]?: SourceItem[];
  [SourceType.Dependency]?: SourceItem[];
  [SourceType.Dataset]?: SourceItem[];
  columnGroups?: SourceColumnGroup[];
  sheets?: SourceSheetGroup[];
}
